// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(fraudType) {
  switch (fraudType) {
    case /* GeoSpoofing */0 :
        return "GEO_SPOOFING";
    case /* Undercut */1 :
        return "UNDERCUT";
    case /* MultiAccounting */2 :
        return "MULTI_ACCOUNTING";
    case /* Theft */3 :
        return "THEFT";
    case /* Other */4 :
        return "OTHER";
    
  }
}

function toDisplayString(fraudType) {
  switch (fraudType) {
    case /* GeoSpoofing */0 :
        return "Geo Spoofing";
    case /* Undercut */1 :
        return "Undercut";
    case /* MultiAccounting */2 :
        return "Multi Accounting";
    case /* Theft */3 :
        return "Theft";
    case /* Other */4 :
        return "Other";
    
  }
}

function toDescription(fraudType) {
  switch (fraudType) {
    case /* GeoSpoofing */0 :
        return "Partner is manipulating their GPS location";
    case /* Undercut */1 :
        return "Partner is undercutting prices";
    case /* MultiAccounting */2 :
        return "Partner has multiple accounts";
    case /* Theft */3 :
        return "Partner has committed theft";
    case /* Other */4 :
        return "Other fraud type (specify in comments)";
    
  }
}

function toApiValue(fraudType) {
  switch (fraudType) {
    case /* GeoSpoofing */0 :
        return "geo_spoofing";
    case /* Undercut */1 :
        return "undercut";
    case /* MultiAccounting */2 :
        return "multi_accounting";
    case /* Theft */3 :
        return "theft";
    case /* Other */4 :
        return "undefined";
    
  }
}

function fromString(value) {
  switch (value) {
    case "GEO_SPOOFING" :
        return /* GeoSpoofing */0;
    case "MULTI_ACCOUNTING" :
        return /* MultiAccounting */2;
    case "OTHER" :
        return /* Other */4;
    case "THEFT" :
        return /* Theft */3;
    case "UNDERCUT" :
        return /* Undercut */1;
    default:
      return ;
  }
}

var allFraudTypes = [
  /* GeoSpoofing */0,
  /* Undercut */1,
  /* MultiAccounting */2,
  /* Theft */3,
  /* Other */4
];

export {
  toString ,
  toDisplayString ,
  toDescription ,
  toApiValue ,
  fromString ,
  allFraudTypes ,
  
}
/* No side effect */
